import { crudActions } from "@/services/CrudActions";

export default {
  ...crudActions("product-categories"),
};
